import { FC } from "react";
import { useTranslation } from "react-i18next";

import { isTranslationKey } from "../localize.helpers";
import { ToastActionBoxStyled } from "./toast-widgets.styled";

interface IToastActionBox {
  message: string;
  actionLabel: string;
  onAction: () => void;
}

/** Toast body with a single inline action, for offers the user may follow up on ("… To courses page"). */
export const ToastActionBox: FC<IToastActionBox> = ({
  message,
  actionLabel,
  onAction,
}) => {
  const { t } = useTranslation();

  return (
    <ToastActionBoxStyled>
      <span className="toast-message">
        {isTranslationKey(message) ? t(message) : message}
      </span>
      <button type="button" className="toast-action" onClick={onAction}>
        {isTranslationKey(actionLabel) ? t(actionLabel) : actionLabel}
      </button>
    </ToastActionBoxStyled>
  );
};
